
export enum StatusKenoby {

    Pending = 1,
    integrated = 2,
    declined = 3,

}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusKenoby.ts